<template>
  <div class="catalog-links text-light flex-column">
    <header>
      <div class="title-1">Catálogos</div>
      <img class="img" :src="require(`@/assets/logos/logo-secondary.png`)" width="250">
    </header>
    <div class="flex-column align-center">

      <div class="catalogo-section">
        <div v-for="(state, index) in states" :key="index">
        <h3 @click="state.isExpanded = !state.isExpanded" :class="state.isExpanded ? 'catalog-open' : ''">
          {{ state.title }}
          <span class="line"></span>
          <svg width="40px" height="40px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 15L12 9L6 15" stroke="#fff" stroke-width="2"/>
          </svg>
        </h3>

        <collapse-transition>
          <div v-show="state.isExpanded">
            <a v-for="(catalog, i) in state.catalogs" :key="i" @click="downloadPdf(catalog.href, catalog.label)" class="catalogo-link">
              <button class="btn-primary flex justify-center align-center">
                <span class="pdf-background">PDF</span>
                <span>{{ catalog.label }}</span>
                <svg width="20" height="20" viewBox="0 0 75 75" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M37.499 56.0001L14.374 32.8751L20.849 26.1689L32.874 38.1939V0.500122H42.124V38.1939L54.149 26.1689L60.624 32.8751L37.499 56.0001ZM9.74902 74.5001C7.20527 74.5001 5.02844 73.5952 3.21852 71.7852C1.40861 69.9753 0.502107 67.797 0.499023 65.2501V51.3751H9.74902V65.2501H65.249V51.3751H74.499V65.2501C74.499 67.7939 73.5941 69.9722 71.7841 71.7852C69.9742 73.5982 67.7959 74.5032 65.249 74.5001H9.74902Z" fill="#505050"/>
                </svg>
              </button>
            </a>
          </div>
        </collapse-transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CollapseTransition } from '@ivanv/vue-collapse-transition'
import api from '@/services/api'

export default {
  name: 'Catalogs',
  components: {
    CollapseTransition
  },
  data () {
    return {
      states: []
    }
  },
  async created () {
    await this.fetchCatalogs()
  },
  methods: {
    normalizeCatalogsPayload (payload) {
      if (Array.isArray(payload)) return payload
      if (payload && Array.isArray(payload.catalogs)) return payload.catalogs
      if (payload && payload.data && Array.isArray(payload.data.catalogs)) return payload.data.catalogs
      return []
    },
    buildStates (catalogs) {
      const byState = {}
      catalogs.forEach(catalog => {
        const stateKey = catalog.state || catalog.uf || 'Outros'
        const label = catalog.title || catalog.name || 'Catálogo'
        const href = catalog.fileUrl || catalog.file_url || catalog.url || ''

        if (!byState[stateKey]) {
          byState[stateKey] = {
            title: stateKey,
            catalogs: [],
            isExpanded: false
          }
        }

        if (href) {
          byState[stateKey].catalogs.push({ label, href })
        }
      })

      return Object.values(byState)
    },
    async fetchCatalogs () {
      try {
        const data = await api.getCatalogs()
        const catalogs = this.normalizeCatalogsPayload(data)
        this.states = this.buildStates(catalogs)
      } catch (error) {
        console.error('Erro ao carregar catálogos:', error)
        this.states = []
      }
    },
    handleAccordion (selectedIndex) {
      this.states.forEach((_, index) => {
        this.states[index].isExpanded = index === selectedIndex ? !this.states[index].isExpanded : false
      })
    },
    downloadPdf (pdfUrl, pdfFileName) {
      const link = document.createElement('a')
      link.href = pdfUrl
      link.target = '_blank'
      link.download = pdfFileName

      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}
</script>

<style lang="scss" scoped>
  .catalog-links {
    .title-1 {
      margin: 20px 0;
    }
    .btn-primary {
      background: #C3C3C3;
      color: #3e3e3e;
      font-size: 15px;
      font-weight: 700;
      margin-top: 20px;
      min-width: 290px;
      min-height: 50px;
      gap: 12px;
    }
    .catalogo-link {
      text-decoration: none;
    }
    .pdf-background {
      position: absolute;
      font-size: 28px;
      font-weight: 900;
      opacity: .2;
      letter-spacing: 20px;
    }
    .catalogo-section h3 {
      display: flex;
      width: 300px;
      cursor: pointer;
      align-items: center;
      gap: 8px;
      .line {
        background: #fff;
        width: 100%;
        height: 1px;
      }
      svg {
        transition: all .5s ease;
      }
    }
    .catalog-open {
      svg {
        transform: rotate(180deg);
      }
    }
  }
</style>